import { render, staticRenderFns } from "./ProductComparisonSection.vue?vue&type=template&id=2db32b89&scoped=true"
import script from "./ProductComparisonSection.vue?vue&type=script&lang=js"
export * from "./ProductComparisonSection.vue?vue&type=script&lang=js"
import style0 from "./ProductComparisonSection.vue?vue&type=style&index=0&id=2db32b89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db32b89",
  null
  
)

export default component.exports